<template>
  <div class="box">
    <div style="width:540px;height:210px">
      <vueCropper
        ref="cropper"
        :img="img"
        
        :outputSize="example2.size"
        :outputType="example2.outputType"
        :info="example2.info"
        :canScale="example2.canScale"
        :autoCrop="example2.autoCrop"
        :fixed="example2.fixed"
        :fixedNumber="fixedNumber"
        :full="true"
      ></vueCropper>
    </div>
    <div class="box">
      <div style="text-align: center;">
        <div style="padding: 10px 0" @click="changeScale(1)">
          <Icon type="android-add-circle" size="20"></Icon>
        </div>
        <div style="padding: 10px 0" @click="changeScale(-1)">
          <Icon type="android-remove-circle" size="20"></Icon>
        </div>
        <div style="padding: 10px 0" @click="rotateRight()">
          <Icon type="loop" size="20"></Icon>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {},
  props: {
    img: {
      type: String,
      default: ""
    },
    fixedNumber: {
      type: Array,
      default: [2, 1]
    },
    fixed: {
      type: Boolean,
      default:true, // 固定裁剪框
    },
    autoCrop: {
      type: Boolean,
      default:true, // 是否默认生成截图框
    }
  },
  data() {
    return {
      example2: {
        info: true,
        size: 0.8, // 输出图片质量
        outputType: "jpeg", // 输出图片格式
        canScale: true,
        autoCrop: true,
        fixed: true, // 固定裁剪框
        fixedNumber: [2, 1] // 宽度和高度比例
      },
    };
  },
  watch:{
    fixed:{
      handler(val){
        this.example2.fixed = val;
      },
      deep: true,
      immediate: true
    },
    autoCrop:{
      handler(val){
        this.example2.autoCrop = val;
      },
      deep: true,
      immediate: true
    }
  },
  components: {},
  methods: {
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    finish(type) {
      // 输出
      if (type === "blob") {
        this.$refs.cropper.getCropBlob(data => {
          var test = window.open("");
          this.$emit("finishend", data);
        });
      } else {
        this.$refs.cropper.getCropData(data => {
          this.$emit("finishend", data);
        });
      }
    }
  }
};
</script>

<style>
</style>
